import { Component, inject } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LombardConfirmationModalComponent } from '../lombard-confirmation-modal/lombard-confirmation-modal.component';

@Component({
  selector: 'lombard-confirmation-reminder',
  templateUrl: './lombard-confirmation-reminder.component.html',
  imports: [TranslocoPipe],
})
export class LombardConfirmationReminderComponent {
  readonly #modal = inject(NgbModal);

  public openModal = (): void => {
    this.#modal.open(LombardConfirmationModalComponent, { size: 'lg' });
  };
}
